export const BUS_STRINGS = [ 'autocar', 'bus', 'navette' ];
export const TAXI_STRINGS = [ 'taxi privé', 'taxi partagé' ];
export const FUNICULAR_STRINGS = [ 'funicular', 'funiculaire' ];